// Load jQuery and jQuery UI libraries
var script1 = document.createElement('script');
script1.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
document.getElementsByTagName('head')[0].appendChild(script1);

var link1 = document.createElement('link');
link1.rel = 'stylesheet';
link1.href = 'https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css';
document.getElementsByTagName('head')[0].appendChild(link1);

var script2 = document.createElement('script');
script2.src = 'https://code.jquery.com/ui/1.12.1/jquery-ui.min.js';
document.getElementsByTagName('head')[0].appendChild(script2);
